import types from '../mutation-types';

import { REPLY_EDITOR_MODES } from 'dashboard/components/widgets/OtelloWriter/constants';
import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';

const MAX_DRAFTS = 50;

function persistToLocalStorage(records) {
  try {
    LocalStorage.set(LOCAL_STORAGE_KEYS.DRAFT_MESSAGES, records);
  } catch (e) {
    if (e.name === 'QuotaExceededError' || e.code === 22) {
      // Quota exceeded: drop oldest half of drafts and retry
      const keys = Object.keys(records);
      const toRemove = keys.slice(0, Math.ceil(keys.length / 2));
      toRemove.forEach((k) => delete records[k]);
      try {
        LocalStorage.set(LOCAL_STORAGE_KEYS.DRAFT_MESSAGES, records);
      } catch (_retryError) {
        // Last resort: clear all drafts from localStorage
        LocalStorage.remove(LOCAL_STORAGE_KEYS.DRAFT_MESSAGES);
      }
    }
  }
}

function evictOldDrafts(records) {
  const keys = Object.keys(records);
  if (keys.length <= MAX_DRAFTS) return;
  // Remove oldest entries (first inserted) to stay under the limit
  const toRemove = keys.slice(0, keys.length - MAX_DRAFTS);
  toRemove.forEach((k) => delete records[k]);
}

const state = {
  records: LocalStorage.get(LOCAL_STORAGE_KEYS.DRAFT_MESSAGES) || {},
  replyEditorMode: REPLY_EDITOR_MODES.REPLY,
};

export const getters = {
  get: (_state) => (key) => {
    return _state.records[key] || '';
  },
  getReplyEditorMode: (_state) => _state.replyEditorMode,
};

export const actions = {
  set: async ({ commit }, { key, message }) => {
    commit(types.SET_DRAFT_MESSAGES, { key, message });
  },
  delete: ({ commit }, { key }) => {
    commit(types.REMOVE_DRAFT_MESSAGES, { key });
  },
  setReplyEditorMode: ({ commit }, { mode }) => {
    commit(types.SET_REPLY_EDITOR_MODE, { mode });
  },
};

export const mutations = {
  [types.SET_DRAFT_MESSAGES]($state, { key, message }) {
    $state.records[key] = message;
    evictOldDrafts($state.records);
    persistToLocalStorage($state.records);
  },
  [types.REMOVE_DRAFT_MESSAGES]($state, { key }) {
    const { [key]: draftToBeRemoved, ...updatedRecords } = $state.records;
    $state.records = updatedRecords;
    persistToLocalStorage($state.records);
  },
  [types.SET_REPLY_EDITOR_MODE]($state, { mode }) {
    $state.replyEditorMode = mode;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
